import { Ng2StateDeclaration } from "@uirouter/angular";
import { AppsService } from "../../commons/services/applications.service";
import { IUserProfile } from "../../types/user";
import { currentUserToken } from "app/root/app.root.resolvers";

export const openairDashboardStateDeclaration: Ng2StateDeclaration = {
  name: 'openairdashboard',
  parent: 'ng2Root',
  url: '/',
  resolve: [
    {
      provide: "applications",
      useFactory: (service: AppsService, profile: IUserProfile) => service.getApplications(profile.openairApps),
      deps: [
        AppsService,
        currentUserToken
      ]
    }
  ],
  onEnter: (transition) => {
    return transition.injector().getAsync<{ link: string }[]>('applications')
      .then(apps => {
        if (!apps || apps.length < 1) return;
        return transition.router.stateService.target(apps[0].link);
      });
  }
}
